export default __webpack_public_path__ + "static/media/pv.3b0e33bb.jpeg";